/**
 * Stable names shared by generated standalone runtime scripts, build-time
 * validation, and application-side Debug tooling. Changing one of these values
 * is a protocol migration rather than an internal rename.
 */
export const FILE_PROTOCOL_STANDALONE_GLOBAL_NAME = '__FILE_PROTOCOL_STANDALONE__' as const;

export const FILE_PROTOCOL_STANDALONE_SCRIPT_PHASE_ATTRIBUTE = 'data-file-protocol-standalone-script-phase' as const;
export const FILE_PROTOCOL_STANDALONE_PRE_RUNTIME_SCRIPT_PHASE = 'pre-runtime' as const;

export const DEBUG_FILE_PROTOCOL_STANDALONE_STARTUP_FORMAT = 'file-protocol-standalone-startup-v2' as const;
export const DEBUG_FILE_PROTOCOL_STANDALONE_DIAGNOSTICS_FORMAT = 'file-protocol-standalone-diagnostics-v2' as const;
export const DEBUG_FILE_PROTOCOL_STANDALONE_BUILD_REPORT_FORMAT = 'file-protocol-standalone-build-report-v5' as const;

export const FILE_PROTOCOL_STANDALONE_ELEMENT_IDS = {
  systemJsRuntime: 'file-protocol-standalone-systemjs-runtime',
  systemJsFilePatch: 'file-protocol-standalone-systemjs-file-patch',
  systemJsRetryHook: 'file-protocol-standalone-systemjs-retry-hook',
  entryBootstrap: 'file-protocol-standalone-entry',
} as const;

export const FILE_PROTOCOL_STANDALONE_GENERATED_ELEMENT_IDS = [
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsRuntime,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsFilePatch,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsRetryHook,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.entryBootstrap,
] as const;

export const FILE_PROTOCOL_STANDALONE_EXECUTABLE_ELEMENT_IDS = [
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsRuntime,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsFilePatch,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.systemJsRetryHook,
  FILE_PROTOCOL_STANDALONE_ELEMENT_IDS.entryBootstrap,
] as const;

// Export internal state and logic used only for testing here. Do not reference these in production logic.
// ESLint-required for TypeScript modules.
export const TEST_ONLY = {
};
